import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import styles from './standard_dialog.less'
import * as dialogStyles from './../dialog/dialog.less'
import { Link } from 'react-router'
import { glimpseRoute } from 'lib/route_utils'
import { Dialog, Button } from '@paypalcorp/pp-react'

class StandardDialog extends React.Component {
  static propTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.string,
    okButtonTitle: PropTypes.string,
    closeButtonTitle: PropTypes.string,
    onOk: PropTypes.func,
    onClose: PropTypes.func,
    onQuit: PropTypes.func,
    isDelete: PropTypes.bool,
    size: PropTypes.string,
  }

  render() {
    let propsToTransfer = { ...this.props }
    delete propsToTransfer.styles
    return (
      <Dialog
        containerClassName={dialogStyles[`${this.props.size}-dialog`]}
        isOpen={true}
        onClose={this.props.onClose}
      >
        <div styleName="dialog-content">
          <div styleName="title">{this.props.title}</div>
          <div styleName="subtitle">{this.props.subtitle}</div>
          {this.props.okButtonTitle &&
            !this.props.isDelete && (
              <Button
                className="vx_btn vx_btn-block"
                styleName="ok-button"
                onClick={this.props.onOk}
              >
                {this.props.okButtonTitle}
              </Button>
            )}
          {this.props.okButtonTitle &&
            this.props.isDelete && (
              <Link
                to={glimpseRoute('edit', 'delete/review')}
                data-nemo="deleteButton"
                className="vx_btn vx_btn-block"
                styleName="delete-button"
                onClick={this.props.onOk}
              >
                {this.props.okButtonTitle}
              </Link>
            )}
          <Button
            className="vx_btn vx_btn-block vx_btn-secondary"
            styleName="close-button"
            onClick={this.props.onQuit ? this.props.onQuit : this.props.onClose}
            secondary
          >
            {this.props.closeButtonTitle}
          </Button>
        </div>
      </Dialog>
    )
  }
}

export default cssModules(StandardDialog, styles)
